export default (params) => ({
  trigger: {
    name: 'wishlist.select_wishlist',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'header',
          'bottom_navigation',
          'top_of_the_page',
          'pop-up',
        ],
      },
    },
    event: {
      name: 'select_content',
      params: {
        content: 'wishlist',
      },
    },
  },
});
